"use client"

import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function CopyIcon({ className }: Props) {
  const { t } = useLingui()

  return (
    <svg
      data-testid="copy-icon"
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{t`Copy Icon`}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66711 2.58356C6.2529 2.58356 5.91711 2.91934 5.91711 3.33356V5.91711H3.33356C2.91934 5.91711 2.58356 6.2529 2.58356 6.66711V12.6675C2.58356 13.0817 2.91934 13.4175 3.33356 13.4175H9.33397C9.74819 13.4175 10.084 13.0817 10.084 12.6675V10.084H12.6675C13.0817 10.084 13.4175 9.74819 13.4175 9.33397V3.33356C13.4175 2.91934 13.0817 2.58356 12.6675 2.58356H6.66711ZM10.084 8.58397H11.9175V4.08356H7.41711V5.91711H9.33397C9.74819 5.91711 10.084 6.2529 10.084 6.66711V8.58397ZM4.08356 11.9175V7.41711H8.58397V11.9175H4.08356Z"
        fill="currentColor"
      />
    </svg>
  )
}
